import { AbstractControl, ValidationErrors } from '@angular/forms';
import { REGEX } from './regex.util';

export function phoneValidator(control: AbstractControl): ValidationErrors | null {
	if (control.value) {
		const stripped = control.value.replace(/\s/g, '');
		const valid = REGEX.PHONE_REGEX.test(stripped);

		if (!valid) {
			return {
				format: true,
			};
		}
	}

	return null;
}
